module.exports = __webpack_public_path__ + "static/media/2nd-chance.235fd121.svg";